import Vue from 'vue';
import Component from 'vue-class-component';
import ValidPatterns from '../utils/types/ValidPatterns';
import { ref } from 'vue';
import { getCurrentInstance } from 'vue';

export function useInputValidation() {
    const vm = getCurrentInstance();

    const rules = new ValidPatterns((vm.proxy as any).$t).getRules();
    const isValid = ref(false);

    function validationReset() {
        isValid.value = false;
    }

    return {
        rules,
        isValid,
        validationReset,
    };
}

@Component
export default class InputValidation extends Vue {
    rules = new ValidPatterns((this as any).$t).getRules();

    isValid = false;

    validationReset(): void {
        this.isValid = false;
    }
}
